import { useEffect, useState } from 'react';
import ChatContainer from 'components/ChatContainer';
import { ChatInput } from 'components';
import Loader from 'components/Loader';
import { useSocket } from 'App';
import './ChatPage.scss';
 


function ChatPage() { 
  const socket = useSocket();
  
  const [messages, setMessages] = useState<ChatMessageProps[]>(
    [
      { role: 'assistant', content: `Hi! Here are a few questions to help you identify the best hoodie for you.
  **What do you believe is true about yourself in this situation that causes you to think, feel, or behave the way you do?**`}
    ],
    
  );
  const [loading, setLoading] = useState(false);
 
  const handleOnSubmit = (value: string) => { 
    setLoading(true);

    socket?.emit('chat-message', {
      history: [...messages, { role: 'user', content: value }]
    });

    setMessages([...messages, { role: 'user', content: value }]); 
  };


  useEffect(() => {
    if (socket) { 
      const handleMessageResponse = (data: ChatMessageProps) => {
        setLoading(false); 
        setMessages((prevMessages) => [...prevMessages, data]);
      };
      socket.on('chat-message:response', handleMessageResponse);

      return () => {
        socket.off('chat-message:response', handleMessageResponse); 
      };
    }
  }, [socket]);
  

 

  return (
    <div className="chat-page">
      <ChatContainer messages={messages} />
      <ChatInput onSubmit={handleOnSubmit} disabled={loading}/>
    </div>
  );
}

export default ChatPage;
